import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NewsService {

  constructor(private http:HttpClient) { }

  getNieuws() {
    return this.http.get<any>(`${environment.apiBaseUrl}/nieuwtjes?populate=*`);
  }
}
